import { useEffect, useState } from "react";
import { TeamCard } from "../components";
import Loader from "../components/Loader";
import { useDispatch, useSelector } from "react-redux";
import { getTeamsDoubles } from "../redux/actions/actions";

export default function Teams() {
	const dispatch = useDispatch();
	const teams = useSelector((state) => state.teamsDoubles);
	const theme = useSelector((state) => state.theme);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (teams.length === 0) dispatch(getTeamsDoubles());
	}, [dispatch, teams]);

	useEffect(() => {
		if (teams.length !== 0) setLoading(false);
	}, [teams]);

	return (
		<div
			className={`flex flex-col max-lg:gap-3 gap-6 mt-2 items-center justify-center`}
		>
			{loading ? (
				<div className={`flex justify-center items-center h-[60svh]`}>
					<Loader className={`w-10`} />
				</div>
			) : (
				<div className={`w-full max-w-[800px] px-2`}>
					{teams?.length === 0 ? (
						<p className={`text-center text-${theme}-primaryColor text-sm`}>
							No hay equipos registrados.
						</p>
					) : (
						<div
							className={`grid grid-cols-2 gap-4 max-lg:grid-cols-1 max-lg:gap-2`}
						>
							{teams?.map((team) => (
								<div key={team.id}>
									<TeamCard team={team} />
								</div>
							))}
						</div>
					)}
				</div>
			)}
		</div>
	);
}
